/* eslint-disable id-match */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { getCountryCurrency } from '../../../../helpers/currency';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingCalendarPrice = ({ price }) => {
  const theme = useContext(ThemeContext);
  const currencySymbol = getCountryCurrency();

  return (
    <>
      <div className="bcal-price-per-person">
        Price per Person:&nbsp;
        <span className="bcal-price-per-person__price">
          {currencySymbol}
          {price}
        </span>
      </div>
      <style jsx>{`
        .bcal-price-per-person {
          background-color: ${theme.commoncolors.white};
          border: 2px solid ${theme.commoncolors.greyshade};
          border-radius: 5px;
          font-size: 15px;
          font-weight: bold;
          margin: 15px 0;
          padding: 10px;
          text-align: center;
        }
        .bcal-price-per-person__price {
          color: ${theme.colors.primary};
          font-size: 19px;
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

BookingCalendarPrice.propTypes = {
  price: PropTypes.number.isRequired,
};

export default BookingCalendarPrice;
